import type { BroadcastChannel } from '~/types/broadcast-message'
import type { Template } from '~/types/template'

export function isSendable(t: Pick<Template, 'channel' | 'status'>): boolean {
  return t.channel === 'whatsapp' ? t.status === 'approved' : t.status === 'ready'
}

export function twilioFriendlyName(name: string, version: number): string {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
  return `${slug}_v${version}`
}

export function templateBodyText(channel: BroadcastChannel, content: Record<string, any>): string {
  if (channel === 'email') return `${content?.subject ?? ''}\n${content?.html ?? ''}`
  if (channel === 'push') return `${content?.title ?? ''}\n${content?.body ?? ''}`
  return String(content?.body ?? '')
}
